import React from "react";
import { ReactFlow } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { NodeWithImage } from "./components/NodeWithImage";
import { IconGridNode } from "./components/IconGridNode";
import { useDiagramData } from "./hooks/useDiagramData";

const nodeTypes = {
  customNode: NodeWithImage,
  iconGridNode: IconGridNode,
};

export const DiagramBasic = () => {
  const { nodes, edges } = useDiagramData();

  return (
    <div
      style={{
        marginTop: 40,
        position: "relative",
        minWidth: "1000px",
        width: "1400px",
        height: "600px",
        marginLeft: "10%",
        alignItems: "center",
      }}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        draggable={false}
        panOnDrag={false}
        zoomOnScroll={false}
        panOnScroll={false}
        maxZoom={0.8}
        style={{ width: "100%", height: "100%", zIndex: 9999 }}
        minZoom={0.8}
      />
    </div>
  );
};
